export const PRODUCT_LOV_TYPES = {
  PRODUCT_LINE_COLOUR: 'PRODUCT_LINE_COLOUR',
  PRODUCT_STATUS: 'PRODUCT_STATUS',
  PRODUCT_CATEGORY: 'PROD_LN_CAT',
  PRODUCT_SUB_CATEGORY: 'PROD_LN_CAT_SUB',
  PRODUCT_SIZE: 'PRODUCT_SIZE',
  PRODUCT_BRAND: 'PRODUCT_BRAND',
  PRODUCT_TYPE: 'PRODUCT_TYPE',
  PRODUCT_SUB_TYPE: 'PRODUCT_TYPE_SUB',
  PRODUCT_UOM: 'PRODUCT_UOM',
  PRODUCT_MARGIN_TYPE: 'PRODUCT_MARGIN_TYPE',
  PRODUCT_WEBSITE_STATUS: 'PRODUCT_WEBSITE_STATUS',
  PRODUCT_PRICE_LIST_TYPE: 'PRODUCT_PRICE_LIST_TYPE',
  PRODUCT_PRICE_LIST_TAX: 'ORDER_TAX',
  PRODUCT_REFRESH_PRICE_LIST_TYPE: 'REFRESH_PRICE_TYPE',
};

export const ACCOUNT_LOV_TYPES = {
  ACCOUNT_TYPE: 'ACCOUNT_TYPE',
  ACCOUNT_STATUS: 'ACCOUNT_STATUS',
  ACCOUNT_CATEGORY: 'ACCOUNT_CATEGORY',
  // Add more account types as needed
};

export const ALL_MODULE_TYPES = {
  PRODUCT: PRODUCT_LOV_TYPES,
  ACCOUNT: ACCOUNT_LOV_TYPES,
  // Add more modules as needed
}; 